export const searchPlaceholder = 'Pesquise por conta sinacor sem o digito';

export const hideUpdate = true;
